/**
 * Turn API HTML snippets (e.g. `<ul class='error-messages-list'>…`) or plain strings
 * into readable text for inline UI (tables, labels). Safe: no HTML execution.
 */
export function htmlOrTextToPlain(s: string): string {
  const t = s.trim()
  if (!t) return ''
  if (!t.includes('<')) return t
  if (typeof document === 'undefined') {
    return t.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
  }
  const doc = new DOMParser().parseFromString(t, 'text/html')
  const text = doc.body.textContent ?? ''
  return text.replace(/\s+/g, ' ').trim()
}
